import { getAuth } from "firebase/auth";
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CryptoService } from '@riise/core/services/crypto/crypto.service';



@Injectable({
    providedIn: 'root',
})


export class UserData {
    private router = inject(Router);
    private crypto = inject(CryptoService);


    public userId: any;
    public userInfos: any;
    public reference: any;
    public referenceId: any;
    public flags: any;
    public space: any;
    public spaceName: any;
    public role: any;
    public roleName: any;
    public currency: string = " F CFA"
    public code: string = "(225) "
    public index: any;
    public user: any;
    decryptedUserData: any;




    constructor() {

        this.user = JSON.parse(localStorage.getItem('user')!);
        this.decryptedUserData = this.crypto.decryptData(this.user)
        this.index = JSON.parse(localStorage.getItem('index')!);

        if (this.decryptedUserData) {
            this.userId = this.decryptedUserData?.uid;
            this.userInfos = this.decryptedUserData;
            this.space = this.decryptedUserData?.flags[this.index]?.id
            this.spaceName = this.decryptedUserData?.flags[this.index]?.name
            this.role = this.decryptedUserData?.flags[this.index]?.roles[0]?.roleId
            this.roleName = this.decryptedUserData?.flags[this.index]?.roles[0]?.roleName
            this.flags = this.decryptedUserData?.flags
            this.reference = this.decryptedUserData?.flags[this.index]?.roles[0]?.reference
            this.referenceId = this.reference.split(",")[0].trim();
        } else {
            localStorage.clear();
            getAuth().signOut().then(() => {
                this.router.navigate(['/'], { replaceUrl: true });
                setTimeout(() => {
                  location.reload();
                }, 100);
            });
        }

    }



}
